import React, { useState, useEffect } from "react";
import {
  TextField,
  Modal,
  Paper,
  Button
} from "@mui/material";
import { resendMFA } from "../services/authAPI";

function MFAConfirmModal({
    open,
    onClose,
    email,
    password,
    mfaCode,
    setMFACode,
    setError,
    handleSubmit,
    setOpen,
}) {
  const handleResendEmail = async (e) => {
    if (e) {
      e.preventDefault();
    }

    setError("");

    try {
      await resendMFA(email, password);
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Unable to re-send MFA Email");
    }
  }

  const handleCancel = (e) => {
    if (e) {
      e.preventDefault();
    }

    setMFACode("")
    setOpen(false);
  }

  const wrapSubmit = async (e) => {
    await handleSubmit(e);
    setOpen(false);
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Paper sx={{ padding: 2, margin: "auto", marginTop: "10%", width: 350, overflow: 'auto' }}>
        <form onSubmit={wrapSubmit}>
          <div className="mfaStuff">
            <p style={{ color: 'red' }}>An email has been sent to {email}</p>
            
            <TextField
            label="MFA Code"
            type="mfaCode"
            fullWidth
            margin="normal"
            value={mfaCode}
            onChange={(e) => {
              if (e.target.value === "" || (/[0-9\b]/.test(e.target.value) && e.target.value.length < 7)) {
                setMFACode(e.target.value);
              } else {
                e.preventDefault();
              }
            }}
            />

            <div style={{ float: 'left', width: '40%', display: 'flex', gap: '10px' }}>
              <Button onClick={handleResendEmail} variant="contained" color="secondary" fullWidth>
                  Resend Email
              </Button>
            </div>
            <div style={{float: 'right', width: '50%', display: 'flex', gap: '10px' }}>
              <Button type="submit" variant="contained" color="primary" fullWidth>
                Submit
              </Button>
              <Button onClick={handleCancel} variant="contained" color="secondary" fullWidth>
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </Paper>
    </Modal>
  );
}

export default MFAConfirmModal;